import raw from "../../data/tables/art/packs/infinite-war/grips.json";
import type { GripPack } from "./grip-resolve";

/** Infinite War grip SSOT. */
export const infiniteWarGripPack = raw as unknown as GripPack;
